import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../web/components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	logo: {
		maxHeight: 40,
		maxWidth: 200,
		width: '100%',
	},
	logoCompact: {
		height: SPACE[28],
		width: 'auto',
	},
	logoLink: {
		display: 'flex',
		justifyContent: 'center',
		width: '100%',
	},
	menuIcon: {
		display: 'block',
		flexShrink: 0,
		height: SPACE[20],
		width: SPACE[20],
	},
	menuItem: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	nav: {
		display: 'flex',
		flexDirection: 'column',
	},
	searchButton: {
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		fontSize: 'inherit',
		gap: 0,
		justifyContent: 'flex-start',
	},
	toggleSlot: {
		bottom: SPACE[12],
		position: 'absolute',
		right: -SPACE[20],
	},
});
